<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 会员设置
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form label-width="80px" ref="form">
                    <el-form-item label="姓名："> {{username}}</el-form-item>
                    <el-form-item label="用户ID："> {{userId}}</el-form-item>
                    <el-form-item label="新密码：">
                        <el-input class="handle-input" placeholder="请输入新密码" v-model="param.password"></el-input>
                    </el-form-item>

                    <el-button @click="updatePwd" icon="el-icon-refresh" type="success">更改密码</el-button>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'basetable',
        data() {
            return {
                param: {
                    name: 'guilin',
                    password: '',
                    id: '007'
                },
                temp: {
                    type: '',
                    userId: ''
                }
            };
        },
        created() {
        },
        computed: {
            username() {
                let username = sessionStorage.getItem('ml_username');
                return username ? username : this.param.name;
            },
            userId() {
                let userId = sessionStorage.getItem('ml_userid');
                this.param.id = userId;
                return userId ? userId : this.param.id;
            }
        },
        methods: {
            async updatePwd() {
                if (Object.keys(this.param.password).length === 0) {
                    return this.$message.error('请输入密码！');
                } else {
                    const { data: res } = await this.$http.post('admin/member/updatePwd', {
                        query: this.param
                    });
                    if (res.code === 200) {
                        this.$message.success(res.message + '，请重新登录!');
                    }
                }
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;

    }

    .handle-input {
        width: 220px;
        margin: 0px 10px;
        display: inline-block;
    }

</style>
